import { useTableContext } from "@/common/contexts/Table.context";
import { cn } from "@/common/utils";
import CustomTypography from "@/components/Typography/CustomTypography";
import { SettingsIcon } from "@/components/icon";
import { Button, InputNumber, Slider } from "antd";
import Dropdown from "antd/es/dropdown/dropdown";
import { FC, useState } from "react";

const RangeFilter: FC<{
  fieldName: string;
  min?: number;
  max?: number;
  title: string;
  titleClassName?: string;
}> = ({ fieldName, min = 1, max = 20, title, titleClassName }) => {
  const { changeFilters } = useTableContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [maxValue, setMaxValue] = useState<number>(max);
  const [minValue, setMinValue] = useState<number>(min);

  const onChangeInputValue = (
    value: number | null,
    indicator: "max" | "min"
  ) => {
    if (value === null) return;
    if (indicator === "max") {
      setMaxValue(value);
    } else {
      setMinValue(value);
    }
  };
  const toggleVisible = (value: boolean) => {
    setIsOpen(value);
  };
  const onRangeChange = (value: number[]) => {
    setMinValue(value[0]);
    setMaxValue(value[1]);
  };

  const applyFilters = () => {
    changeFilters(fieldName, [minValue, maxValue]);
    toggleVisible(false);
  };

  return (
    <div className="cursor-pointer pt-1" onClick={(e) => e.stopPropagation()}>
      <Dropdown
        open={isOpen}
        trigger={["click"]}
        onOpenChange={toggleVisible}
        dropdownRender={() => (
          <div
            className="w-full min-w-fit top-6 rounded-lg flex flex-col gap-3 p-4 bg-white shadow-lg border border-gray-300"
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div className="w-full min-w-fit flex gap-2 items-center justify-center">
              <CustomTypography
                as="span"
                weight={"medium"}
                className="text-nowrap"
                size={"13px"}
              >
                Min value:
              </CustomTypography>
              <InputNumber
                min={min}
                max={max}
                value={minValue}
                className="border-none bg-gray-border font-kanit text-[13px]"
                onChange={(value) => onChangeInputValue(value, "min")}
              />
            </div>
            <div className="w-full min-w-fit flex gap-2 items-center justify-center">
              <CustomTypography
                as="span"
                weight={"medium"}
                className="text-nowrap"
                size={"13px"}
              >
                Max value:
              </CustomTypography>
              <InputNumber
                min={min}
                max={max}
                value={maxValue}
                className="border-none bg-gray-border font-kanit text-[13px]"
                onChange={(value) => onChangeInputValue(value, "max")}
              />
            </div>
            <div>
              <Slider
                range
                min={min}
                max={max}
                value={[minValue, maxValue]}
                onChange={onRangeChange}
              />
            </div>
            <Button type="primary" className="h-10" onClick={applyFilters}>
              <CustomTypography
                as="span"
                family={"inter"}
                weight={"semibold"}
                color={"white"}
              >
                Apply
              </CustomTypography>
            </Button>
          </div>
        )}
      >
        <div
          className={cn(
            "h-full w-full flex justify-left gap-2 items-center -mb-[40px]",
            titleClassName
          )}
        >
          <CustomTypography
            as="span"
            case={"uppercase"}
            family={"kanit"}
            weight={"normal"}
            size={"13px"}
            color={"gray"}
            className="text-nowrap"
          >
            {title}
          </CustomTypography>
          <button onClick={() => setIsOpen((state) => !state)}>
            <span className="block text-gray-dim rotate-90">
              <SettingsIcon width={18} height="19" />
            </span>
          </button>
        </div>
      </Dropdown>
    </div>
  );
};

export default RangeFilter;
